"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canSeeNonMembers = exports.canSeeMembers = exports.canFetchAllMembers = exports.canEdit = exports.canInviteMembers = exports.canWritePost = exports.canJoinGroup = exports.canSeeGroup = exports.canApprovePendingMembers = exports.canSeeFeed = void 0;
var types_1 = require("../../types");
var MemberRole_1 = require("./MemberRole");
var GroupPrivacy_1 = require("../Group/GroupPrivacy");
var Member_1 = require("./Member");
function canSeeFeed(group) {
    return !GroupPrivacy_1.isEmptyGroup(group) && canSeeGroup(group);
}
exports.canSeeFeed = canSeeFeed;
function canApprovePendingMembers(currentMember, group) {
    return (MemberRole_1.isAdmin(currentMember) ||
        (!Member_1.isAnonymous(currentMember) &&
            group.settings.permittedToApproveMembers ===
                types_1.ApiTypes.v1.RoleInGroup.GROUP_MEMBER));
}
exports.canApprovePendingMembers = canApprovePendingMembers;
function canSeeGroup(group) {
    return GroupPrivacy_1.isGroupPublic(group) || MemberRole_1.isAdmin(group) || MemberRole_1.isJoined(group);
}
exports.canSeeGroup = canSeeGroup;
function canJoinGroup(group) {
    return !GroupPrivacy_1.isGroupSecret(group) || MemberRole_1.isAdmin(group);
}
exports.canJoinGroup = canJoinGroup;
function canWritePost(group) {
    return MemberRole_1.isJoined(group);
}
exports.canWritePost = canWritePost;
function canInviteMembers(group) {
    return MemberRole_1.isAdmin(group) || MemberRole_1.hasInvitePermission(group);
}
exports.canInviteMembers = canInviteMembers;
function canEdit(group) {
    return MemberRole_1.isAdmin(group);
}
exports.canEdit = canEdit;
function canFetchAllMembers(group) {
    return canInviteMembers(group);
}
exports.canFetchAllMembers = canFetchAllMembers;
function canSeeMembers(group) {
    var isPublic = GroupPrivacy_1.isGroupPublic(group);
    return MemberRole_1.isAdmin(group) || isPublic || MemberRole_1.isJoined(group);
}
exports.canSeeMembers = canSeeMembers;
function canSeeNonMembers(group) {
    return canInviteMembers(group);
}
exports.canSeeNonMembers = canSeeNonMembers;
//# sourceMappingURL=permissions.js.map